export const APPEARANCE_MODE_STORAGE_KEY = "appearanceMode";

export type AppearanceMode = "light" | "dark" | "system";
export type ResolvedAppearance = "light" | "dark";
export type AppearanceScheme = ResolvedAppearance | "inverse";

export const APPEARANCE_MODE_OPTIONS: AppearanceMode[] = [
	"light",
	"dark",
	"system",
];

export const isAppearanceMode = (value: unknown): value is AppearanceMode => {
	return (
		typeof value === "string" &&
		APPEARANCE_MODE_OPTIONS.includes(value as AppearanceMode)
	);
};

export const getStoredAppearanceMode = (): AppearanceMode => {
	return "light";
	// try {
	// 	const value = localStorage.getItem(APPEARANCE_MODE_STORAGE_KEY);
	// 	return isAppearanceMode(value) ? value : "system";
	// } catch {
	// 	return "system";
	// }
};

export const applyAppearanceMode = (mode: AppearanceMode): void => {
	const root = document.documentElement;
	root.dataset.appearance = mode;
};

export const persistAppearanceMode = (mode: AppearanceMode): void => {
	try {
		localStorage.setItem(APPEARANCE_MODE_STORAGE_KEY, mode);
	} catch {
		// Ignore storage failures (private browsing / blocked storage).
	}
};

export const resolveAppearanceMode = (
	mode: string | undefined,
	prefersDark = false,
): ResolvedAppearance => {
	if (mode === "dark") {
		return "dark";
	}
	if (mode === "light") {
		return "light";
	}
	return prefersDark ? "dark" : "light";
};

export const invertAppearance = (
	scheme: ResolvedAppearance,
): ResolvedAppearance => (scheme === "dark" ? "light" : "dark");

export const readDocumentAppearance = (): ResolvedAppearance => {
	if (typeof document === "undefined") {
		return "light";
	}
	const prefersDark =
		typeof window !== "undefined" &&
		window.matchMedia("(prefers-color-scheme: dark)").matches;
	return resolveAppearanceMode(
		document.documentElement.dataset.appearance,
		prefersDark,
	);
};
